<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main" >
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            
            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2>{{$t('clients.fecha_migracion_solpheo_from_to')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('certificates.from')}}
                        <el-form-item prop="fechaMigracionSolpheoFrom">
                            <el-date-picker
                              class="bg-white dark:bg-darkblue-900"
                              v-model="form.fechaMigracionSolpheoFrom.value"
                              :picker-options="dateRangeOptions"
                              type="date"
                              format="dd-MM-yyyy"
                              placeholder="dd-mm-aaaa"
                              ref="datePickerFechaFrom"
                              @blur="onBlurDatePickerMixin('.datePickerFechaFrom-popover')"
                              @focus="onFocusDatePickerMixin('.datePickerFechaFrom-popover')"
                              @keydown.native="captureKeyNotChrome"
                              popper-class="datePickerFechaFrom-popover"
                              >
                            </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('certificates.to')}}
                        <el-form-item prop="fechaMigracionSolpheoTo">
                          <el-date-picker
                            class="bg-white dark:bg-darkblue-900"
                            v-model="form.fechaMigracionSolpheoTo.value"
                            :picker-options="dateRangeOptions"
                            type="date"
                            format="dd-MM-yyyy"
                            placeholder="dd-mm-aaaa"
                            ref="datePickerFechaTo"
                            @blur="onBlurDatePickerMixin('.datePickerFechaTo-popover')"
                            @focus="onFocusDatePickerMixin('.datePickerFechaTo-popover')"
                            @keydown.native="captureKeyNotChrome"
                            popper-class="datePickerFechaTo-popover"
                            >
                          </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>

            <div v-if="role === 'SuperAdministrador'">
              <AccessibleElSelect
                v-model="form.distribuidor.value"
                prop="distribuidor"
                :options="distribuidoresForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('distributors.distributor')}}</template>
              </AccessibleElSelect>
            </div>
            <div>
              <span id="clients-filter-name-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.name')}}</span>
              <el-form-item prop="name">
                <el-input
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                  aria-labelledby="clients-filter-name-label"
                >
                  <template v-if="form.name.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de nombre"
                      @clear="form.name.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <span id="clients-filter-emailscontacto-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.EmailsContacto')}}</span>
              <el-form-item prop="EmailsContacto">
                <el-input
                  class="w-full"
                  v-model="form.EmailsContacto.value"
                  maxlength="500"
                  aria-labelledby="clients-filter-emailscontacto-label"
                >
                  <template v-if="form.EmailsContacto.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de email de contacto"
                      @clear="form.EmailsContacto.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <span id="clients-filter-codigoexterno-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.cod_ext')}}</span>
              <el-form-item prop="codigoExterno">
                <el-input
                  class="w-full"
                  v-model="form.codigoExterno.value"
                  maxlength="20"
                  aria-labelledby="clients-filter-codigoexterno-label"
                >
                  <template v-if="form.codigoExterno.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de código externo"
                      @clear="form.codigoExterno.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <span id="clients-filter-ns-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.ns')}}</span>
              <el-form-item prop="ns">
                <el-input
                  class="w-full"
                  v-model="form.ns.value"
                  maxlength="255"
                  aria-labelledby="clients-filter-ns-label"
                >
                  <template v-if="form.ns.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de número de serie"
                      @clear="form.ns.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.partner.value"
                prop="partner"
                :options="partnersForAccessibleSelect"
                id-prefix="clientsfilter"
                @change="onChangePartner"
              >
                <template slot="label">{{$t('clients.partner')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.grupoVigilante.value"
                prop="grupoVigilanteId"
                :options="gruposVigilanteForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.grupo_vigilante')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.tipoServicio.value"
                prop="tipoServicio"
                :options="tiposServicioForAccessibleSelect"
                @change="onChangeTipoServicio"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.service_type')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.activo.value"
                prop="activo"
                :options="valuesForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('companies.active')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.codPGNMultiple.value"
                prop="sede"
                :options="sedesForAccessibleSelect"
                :isMultiple="true"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('app.location')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.moduloMultiple.value"
                prop="module"
                :options="modulosForAccessibleSelect"
                :isMultiple="true"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('app.module')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.FaseConfiguracion.value"
                prop="FaseConfiguracion"
                :options="tiposFasesConfiguracionForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.fase_config')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.PaqueteContratacion.value"
                prop="PaqueteContratacion"
                :options="tiposPaquetesContratacionForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.paquete_contratacion')}}</template>
              </AccessibleElSelect>
            </div>
            
            <div>
              <AccessibleElSelect
                v-model="form.organismo.value"
                prop="organismo"
                :options="valuesOrganismosForAccessibleSelect"
                :remote="true"
                :remoteMethod="remoteOrganismos"
                popperClass="wrap-select-popover"
                :loading="loadingOrganismos"
                id-prefix="clientsfilter"
                @select="handleSelectOrganismo"
              >
                <template slot="label">
                  <div class="flex items-center gap-x-2">
                    {{$t('companies.organismo_excluded')}}
                    <base-tooltip-icon size="sm" :content="'Escribe para iniciar la búsqueda'"/>
                  </div>
                </template>
              </AccessibleElSelect>
            </div>

            <div v-if="!disablePendienteEnviarFacturacion">
              <AccessibleElSelect
                v-model="form.PendienteFacturacion.value"
                prop="PendienteFacturacion"
                :options="valuesForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.alta_fact_filter')}}</template>
              </AccessibleElSelect>
            </div>

            <div v-if="hasModuleSAML2">
              <AccessibleElSelect
                v-model="form.certificadoSAML2PorCaducar.value"
                prop="certificadoSAML2PorCaducar"
                :options="valuesForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.certificadoSAML2PorCaducar_filter')}}</template>
              </AccessibleElSelect>
            </div>

            <div v-if="hasModuleSAML2">
              <AccessibleElSelect
                v-model="form.certificadoSAML2Caducado.value"
                prop="certificadoSAML2Caducado"
                :options="valuesForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.certificadoSAML2Caducado_filter')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.idTipoHSM.value"
                prop="idTipoHSM"
                :options="tiposHSMForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.tipo_hsm')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.idTipoCliente.value"
                prop="idTipoCliente"
                :options="tiposClienteForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.tipo_cliente')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.MaquinasNuestras.value"
                prop="MaquinasNuestras"
                :options="valuesForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.maquinas_nuestras')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.TieneMaquinas.value"
                prop="TieneMaquinas"
                :options="valuesForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.tiene_maquinas')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.TercerosBasico.value"
                prop="TercerosBasico"
                :options="valuesForAccessibleSelect"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.terceros_basico')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import moment from 'moment'

import AccessibleElSelect from '../elementui/AccessibleElSelect.vue'
import { getPartners } from '@/services/clients/getPartners'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import { getServiceTypes } from '@/services/app/getServiceTypes'
import { getLocations } from '@/services/app/getLocations'
import { getOrganismosAll } from '@/services/configurations/getOrganismosAll'

import { TIPOS_MODULOS } from '@/config/tipos-modulos'

import { TIPOS_FASES_CONFIGURACION } from '@/config/tipos-fases-configuracion'
import { TIPOS_PAQUETES_CONTRATACION } from '@/config/tipos-paquetes-contratacion'

import { TIPOS_HSM } from '@/config/tipos-hsm'
import { TIPOS_CLIENTE } from '@/config/tipos-cliente'

import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'clients',
      isOpen: this.panelOpen,
      links: [],
      loadingOrganismos: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      form: {
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        name: { label: i18n.t('clients.name'), value: '' },
        codigoExterno: { label: i18n.t('clients.cod_ext'), value: '' },
        EmailsContacto: { label: i18n.t('clients.EmailsContacto'), value: '' },
        ns: { label: i18n.t('clients.ns'), value: '' },
        partner: { label: i18n.t('clients.partner'), value: '', labelValue: '' },
        grupoVigilante: { label: i18n.t('clients.grupo_vigilante'), value: '', labelValue: '' },
        tipoServicio: { label: i18n.t('clients.service_type'), value: '', labelValue: '' },
        FaseConfiguracion: { label: i18n.t('clients.fase_config'), value: '' }, 
        PaqueteContratacion: { label: i18n.t('clients.paquete_contratacion'), value: '' }, 
        activo: { label: i18n.t('companies.active'), value: '' },
        codPGNMultiple: { label: 'Sedes', value: '' },
        moduloMultiple: { label: 'Módulos', value: '' },
        organismo: { label: 'Organismo', value: '' },
        PendienteFacturacion: { label: i18n.t('clients.alta_fact_filter'), value: '' },
        certificadoSAML2PorCaducar: { label: i18n.t('clients.certificadoSAML2PorCaducar_filter'), value: '' },
        certificadoSAML2Caducado: { label: i18n.t('clients.certificadoSAML2Caducado_filter'), value: '' },
        fechaMigracionSolpheoFrom: { label: i18n.t('clients.fecha_migracion_solpheo'), value: '' },
        fechaMigracionSolpheoTo: { label: i18n.t('clients.fecha_migracion_solpheo'), value: '' },
        idTipoHSM: { label: i18n.t('clients.tipo_hsm'), value: '' },
        idTipoCliente: { label: i18n.t('clients.tipo_cliente'), value: '' },
        MaquinasNuestras: { label: i18n.t('clients.maquinas_nuestras'), value: '' },
        TieneMaquinas: { label: i18n.t('clients.tiene_maquinas'), value: '' },
        TercerosBasico: { label: i18n.t('clients.terceros_basico'), value: '' },
      },
      sedes: [],
      modulos: TIPOS_MODULOS,
      tiposFasesConfiguracion: TIPOS_FASES_CONFIGURACION,
      tiposPaquetesContratacion: TIPOS_PAQUETES_CONTRATACION,
      tiposHSM: TIPOS_HSM,
      tiposCliente: TIPOS_CLIENTE,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      valuesOrganismos: [],
      distribuidores: [],
      partners: [],
      gruposVigilante: [],
      tiposServicio: []
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    const dataClients = await getPartners()
    if (dataClients.blnError === false) {
      this.partners = dataClients.TipoServ
      this.$store.dispatch('app/settiposPartners', dataClients.TipoServ)
    } else {
      this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
    }
    const dataGruposVigilante = await getClients({ grupoEmpresas: true })
    if (dataGruposVigilante.blnError === false) {
      this.gruposVigilante = dataGruposVigilante.Empresas
      this.$store.dispatch('app/settiposGruposVigilantes', dataGruposVigilante.Empresas)
    } else {
      this.doFeedback(dataGruposVigilante.msgError + ' [Código de error: ' + dataGruposVigilante.codError + ']')
    }
    const dataServiceTypes = await getServiceTypes()
    if (dataServiceTypes.blnError === false) {
      this.tiposServicio = dataServiceTypes.TipoServ
      this.$store.dispatch('app/settiposServicio', dataServiceTypes.TipoServ)
    } else {
      this.doFeedback(dataServiceTypes.msgError + ' [Código de error: ' + dataServiceTypes.codError + ']')
    }
    if (this.role === 'SuperAdministrador') {
      const dataDistributors = await getDistributors()
      if (dataDistributors.blnError === true) {
        this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
      }
      this.distribuidores = dataDistributors.Distribuidores
    }
    const locs = await getLocations()
    if (locs.blnError === true) {
      this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
    } else {
      locs.PGNS.forEach(row => {
        this.sedes.push({ id: row.IdPGN, label: row.Nombre, value: row.Codigo })
      })
    }
  },
  computed: {
    tiposHSMForAccessibleSelect () {
      return this.tiposHSM.map(tipoHSM => ({
        id: tipoHSM.id,
        name: tipoHSM.name,
        value: tipoHSM.id
      }))
    },
    tiposClienteForAccessibleSelect () {
      return this.tiposCliente.map(tipoCliente => ({
        id: tipoCliente.id,
        name: tipoCliente.name,
        value: tipoCliente.id
      }))
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    disablePendienteEnviarFacturacion () {
      return (this.role === 'SuperAdminDistribuidor' || this.role === 'AdminDistribuidor') &&
      this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 2
    },
    // Computed properties para AccessibleElSelect
    distribuidoresForAccessibleSelect () {
      return this.distribuidores.map(dist => ({ id: dist.Nombre, name: dist.Nombre }))
    },
    partnersForAccessibleSelect () {
      return this.partners.map(partner => ({ id: partner.IdPartner, name: partner.Nombre }))
    },
    gruposVigilanteForAccessibleSelect () {
      return this.gruposVigilante.map(grupo => ({ id: grupo.IdEmpresa, name: grupo.Nombre }))
    },
    tiposServicioForAccessibleSelect () {
      return this.tiposServicio.map(tipo => ({ id: tipo.IdTipoServicio, name: tipo.Descripcion }))
    },
    valuesForAccessibleSelect () {
      return this.values.map(item => ({ id: item.value, name: item.label }))
    },
    sedesForAccessibleSelect () {
      return this.sedes.map(sede => ({ id: sede.value, name: sede.label }))
    },
    valuesOrganismosForAccessibleSelect () {
      return this.valuesOrganismos.map(org => ({ id: org.id, value: org.value, name: org.label }))
    },
    modulosForAccessibleSelect () {
      return this.modulos.map(modulo => ({ id: modulo.id, name: modulo.name }))
    },
    tiposFasesConfiguracionForAccessibleSelect () {
      return this.tiposFasesConfiguracion.map(fase => ({ id: fase.id, name: fase.name }))
    },
    tiposPaquetesContratacionForAccessibleSelect () {
      return this.tiposPaquetesContratacion.map(paquete => ({ id: paquete.id, name: paquete.name }))
    },
    hasModuleSAML2 () {
      return this.$store.getters['auth/hasModuleSAML2']
    },
  },
  methods: {
    cleanMultiples: function () {
      if (Array.isArray(this.form.codPGNMultiple.value) && this.form.codPGNMultiple.value.length === 0) {
        this.form.codPGNMultiple.value = ''
      }
      if (Array.isArray(this.form.moduloMultiple.value) && this.form.moduloMultiple.value.length === 0) {
        this.form.moduloMultiple.value = ''
      }
    },
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.EmailsContacto.value = _temp.EmailsContacto !== undefined && _temp.EmailsContacto.value !== '' ? _temp.EmailsContacto.value : ''
        this.form.codigoExterno.value = _temp.codigoExterno !== undefined && _temp.codigoExterno.value !== '' ? _temp.codigoExterno.value : ''
        this.form.ns.value = _temp.ns !== undefined && _temp.ns.value !== '' ? _temp.ns.value : ''
        this.form.partner.value = _temp.partner !== undefined && _temp.partner.value !== '' ? _temp.partner.value : ''
        this.form.grupoVigilante.value = _temp.grupoVigilante !== undefined && _temp.grupoVigilante.value !== '' ? _temp.grupoVigilante.value : ''
        this.form.tipoServicio.value = _temp.tipoServicio !== undefined && _temp.tipoServicio.value !== '' ? _temp.tipoServicio.value : ''
        this.form.FaseConfiguracion.value = _temp.FaseConfiguracion !== undefined && _temp.FaseConfiguracion.value !== '' ? _temp.FaseConfiguracion.value : ''
        this.form.PaqueteContratacion.value = _temp.PaqueteContratacion !== undefined && _temp.PaqueteContratacion.value !== '' ? _temp.PaqueteContratacion.value : ''
        this.form.activo.value = _temp.activo !== undefined && _temp.activo.value !== '' ? _temp.activo.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.PendienteFacturacion.value = _temp.PendienteFacturacion !== undefined && _temp.PendienteFacturacion.value !== '' ? _temp.PendienteFacturacion.value : ''
        this.form.codPGNMultiple.value = _temp.codPGNMultiple !== undefined && _temp.codPGNMultiple.value !== '' ? _temp.codPGNMultiple.value : ''
        this.form.organismo.value = _temp.organismo !== undefined && _temp.organismo.value !== '' ? _temp.organismo.value : ''
        this.form.moduloMultiple.value = _temp.moduloMultiple !== undefined && _temp.moduloMultiple.value !== '' ? _temp.moduloMultiple.value : ''
        this.form.certificadoSAML2PorCaducar.value = _temp.certificadoSAML2PorCaducar !== undefined && _temp.certificadoSAML2PorCaducar.value !== '' ? _temp.certificadoSAML2PorCaducar.value : ''
        this.form.certificadoSAML2Caducado.value = _temp.certificadoSAML2Caducado !== undefined && _temp.certificadoSAML2Caducado.value !== '' ? _temp.certificadoSAML2Caducado.value : ''
        this.form.fechaMigracionSolpheoFrom.value = _temp.fechaMigracionSolpheoFrom !== undefined && _temp.fechaMigracionSolpheoFrom.value !== '' ? _temp.fechaMigracionSolpheoFrom.value : ''
        this.form.fechaMigracionSolpheoTo.value = _temp.fechaMigracionSolpheoTo !== undefined && _temp.fechaMigracionSolpheoTo.value !== '' ? _temp.fechaMigracionSolpheoTo.value : ''
        this.form.idTipoHSM.value = _temp.idTipoHSM !== undefined && _temp.idTipoHSM.value !== '' ? _temp.idTipoHSM.value : ''
        this.form.idTipoCliente.value = _temp.idTipoCliente !== undefined && _temp.idTipoCliente.value !== '' ? _temp.idTipoCliente.value : ''
        this.form.MaquinasNuestras.value = _temp.MaquinasNuestras !== undefined && _temp.MaquinasNuestras.value !== '' ? _temp.MaquinasNuestras.value : ''
        this.form.TieneMaquinas.value = _temp.TieneMaquinas !== undefined && _temp.TieneMaquinas.value !== '' ? _temp.TieneMaquinas.value : ''
        this.form.TercerosBasico.value = _temp.TercerosBasico !== undefined && _temp.TercerosBasico.value !== '' ? _temp.TercerosBasico.value : ''
      }
    },
    watchFormHandler: function ({ fechaMigracionSolpheoFrom, fechaMigracionSolpheoTo }) {
      // eslint-disable-next-line camelcase
      if (fechaMigracionSolpheoFrom !== undefined && moment(fechaMigracionSolpheoFrom.value).isValid()) {
        this.form.fechaMigracionSolpheoFrom.value = moment(fechaMigracionSolpheoFrom.value).format('YYYY-MM-DD')
      } else {
        this.form.fechaMigracionSolpheoFrom.value = ''
      }
      // eslint-disable-next-line camelcase
      if (fechaMigracionSolpheoTo !== undefined && moment(fechaMigracionSolpheoTo.value).isValid()) {
        this.form.fechaMigracionSolpheoTo.value = moment(fechaMigracionSolpheoTo.value).format('YYYY-MM-DD')
      } else {
        this.form.fechaMigracionSolpheoTo.value = ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        name: { label: i18n.t('clients.name'), value: '' },
        EmailsContacto: { label: i18n.t('clients.EmailsContacto'), value: '' },
        codigoExterno: { label: i18n.t('clients.cod_ext'), value: '' },
        ns: { label: i18n.t('clients.ns'), value: '' },
        partner: { label: i18n.t('clients.partner'), value: '', labelValue: '' },
        grupoVigilante: { label: i18n.t('clients.grupo_vigilante'), value: '', labelValue: '' },
        tipoServicio: { label: i18n.t('clients.service_type'), value: '', labelValue: '' },
        FaseConfiguracion: { label: i18n.t('clients.fase_config'), value: '' }, 
        PaqueteContratacion: { label: i18n.t('clients.paquete_contratacion'), value: '' }, 
        activo: { label: i18n.t('companies.active'), value: '' },
        codPGNMultiple: { label: 'Sedes', value: '' },
        moduloMultiple: { label: 'Módulos', value: '' },
        organismo: { label: 'Organismo', value: '' },
        PendienteFacturacion: { label: i18n.t('clients.alta_fact_filter'), value: '' },
        certificadoSAML2PorCaducar: { label: i18n.t('clients.certificadoSAML2PorCaducar_filter'), value: '' },
        certificadoSAML2Caducado: { label: i18n.t('clients.certificadoSAML2Caducado_filter'), value: '' },
        fechaMigracionSolpheoFrom: { label: i18n.t('clients.fecha_migracion_solpheo_from'), value: '' },
        fechaMigracionSolpheoTo: { label: i18n.t('clients.fecha_migracion_solpheo_to'), value: '' },
        idTipoHSM: { label: i18n.t('clients.tipo_hsm'), value: '' },
        idTipoCliente: { label: i18n.t('clients.tipo_cliente'), value: '' },
        MaquinasNuestras: { label: i18n.t('clients.maquinas_nuestras'), value: '' },
        TieneMaquinas: { label: i18n.t('clients.tiene_maquinas'), value: '' },
        TercerosBasico: { label: i18n.t('clients.terceros_basico'), value: '' },
      }
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    applyFilters: function () {
      this.cleanMultiples()
      if (this.form.partner.value !== '') this.controlLabelPartner(this.form.partner.value)
      if (this.form.grupoVigilante.value !== '') this.controlLabelgrupoVigilante(this.form.grupoVigilante.value)
      if (this.form.tipoServicio.value !== '') this.controlLabelTipoServicio(this.form.tipoServicio.value)
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    onChangePartner: function (value) {
      // console.log('onChangePartner', value)
    },
    onChangeTipoServicio: function (value) {
      // console.log('onChangeTipoServicio', value)
    },
    handleSelectOrganismo: function (item) {
      this.form.organismo.value = item.id
    },
    formatNombreOrg (element) {
      return element.Nombre + ' - ' + element.CIF
    },
    remoteOrganismos: async function (query) {
      this.valuesOrganismos = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismosAll({ filtro: query })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.DatosOrganismos !== undefined && organismos.DatosOrganismos?.length > 0) {
            let organismosMatch = []
            if (organismos.DatosOrganismos.length > 200) {
              organismosMatch = organismos.DatosOrganismos.filter(x => x.CIF.toUpperCase() === query.toUpperCase() || x.Nombre.toUpperCase() === query.toUpperCase())
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.DatosOrganismos
            }
            organismosMatch.forEach(element => {
              this.valuesOrganismos.push(
                { 
                  id: element.idOrganismo, 
                  value: element.Nombre,
                  label: this.formatNombreOrg(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      } else {
        // this.options = []
      }
    },
    controlLabelgrupoVigilante: function (value) {
      const grupoVigilante = this.gruposVigilante.filter(x => {
        return x.IdEmpresa === value
      })
      if (grupoVigilante !== null && grupoVigilante !== undefined) this.form.grupoVigilante.labelValue = grupoVigilante[0].Nombre
    },
    controlLabelPartner: function (value) {
      const partner = this.partners.filter(x => {
        return x.IdPartner === value
      })
      if (partner !== null && partner !== undefined) this.form.partner.labelValue = partner[0].Nombre
    },
    controlLabelTipoServicio: function (value) {
      const tipoServicio = this.tiposServicio.filter(x => {
        return x.IdTipoServicio === value
      })
      if (tipoServicio !== null && tipoServicio !== undefined) this.form.tipoServicio.labelValue = tipoServicio[0].Descripcion
    }
  }
}
</script>
